var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppartments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "appartment",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M11,21V15H7v6ZM7,7h4M7,11h4",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M15,21H3V4A1,1,0,0,1,4,3H14a1,1,0,0,1,1,1Zm0,0h6V7a1,1,0,0,0-1-1H15Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppartments);
export default __webpack_public_path__ + "static/media/Appartments.2b48783d39bd3263c1313b5be4cbcd1a.svg";
export { ForwardRef as ReactComponent };